import { createSelector } from '@reduxjs/toolkit';
import menusSelector from './menus';

const sidebarMenuSelector = createSelector(menusSelector, (menus) => menus.sidebar);

export default sidebarMenuSelector;
